'use strict';
/* COMPONENT - c.06.02 - shop list */

import Listing from './uif_listing.js';

if (document.querySelector('.shop-list')) {
    let shopList = document.querySelectorAll('.shop-list');
    for (let i = 0; i < shopList.length; i++) {
        new Listing(shopList[i]);
    }
}
